import React from "react";
import { H4 } from "../../atoms/Texts";
import { BasicDetailsFields } from "./Fields";
import { FormBuilder } from "./FormBuilder";

export const BasicOrgDetails = () => {
  return (
    <>
      <H4 className="mb-4">Basic Details</H4>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-x-5">
        <FormBuilder key="basic-input" fields={BasicDetailsFields} />
      </section>
    </>
  );
};

export default BasicOrgDetails;
